import React from 'react';

function Features() {
    return (
        <section className="features-section py-5">
            <div className="container">
                <div className="row align-items-center gy-5 gap-5">
                    <div className="col-lg-6">
                        <div className="feature-card text-center text-lg-start">
                            <h4 className="eyebrow">Tailored for Hospitality</h4>
                            <h2>Websites that welcome guests</h2>
                            <p>
                                Professional web solutions for the service industry.
                                Highlight your menu, events, and atmosphere with a clean, modern design.
                            </p>
                        </div>
                    </div>

                    <div className="col-lg-5 text-center text-lg-start">
                        <div className="container">
                            <h3 className="mb-3">What’s Included</h3>
                            <p>
                                Nectr Studio gives your business everything it needs to operate a professional website —
                                including a custom-branded design, easy editing for menus, events, hours, online ordering
                                and delivery integrations, POS system support, mobile-optimized layouts, reservation and
                                contact forms, and optional eCommerce tools for selling merch or gift cards.
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}

export default Features;
